import React, { useEffect } from 'react';
import logo from './logo.svg';
import './App.css';
import { createBrowserRouter, createRoutesFromElements, Route, Router, RouterProvider, Routes } from 'react-router-dom';
import HomePage from './pages/home.page';
import { navigation_constants } from './constants/navigation.constants';
import TOSPage from './pages/tos.page';
import PrivacyPolicyPage from './pages/privacy-policy.page';
import JoinBetaPage from './pages/join-beta.page';
import JoinBetaSuccessPage from './pages/join-beta-success.page';
import DeleteAccountInfoPage from './pages/info/delete-account-info.page';

function App() {
	useEffect(()=>{

	}, [])

	const router = createBrowserRouter([
		{
			path: navigation_constants.pages.home,
			element: <HomePage />,
		},
		{
			path: navigation_constants.pages.tos,
			element: <TOSPage />,
		},
		{
			path: navigation_constants.pages.privacy_policy,
			element: <PrivacyPolicyPage />,
		},
		{
			path: navigation_constants.pages.join_beta,
			element: <JoinBetaPage />,
		},
		{
			path: navigation_constants.pages.join_beta_success,
			element: <JoinBetaSuccessPage />,
		},
		{
			path: navigation_constants.pages.delete_account_steps,
			element: <DeleteAccountInfoPage />,
		},
	]);

	return (
		<RouterProvider router={router} />
	);
}
export default App;
